// extracted by mini-css-extract-plugin
export default {"tradersIframe":"TrustedTraders_tradersIframe__v5nts"};